module.exports = __webpack_public_path__ + "img/quard1.97531bdb.png";